import React, { useState, useEffect } from 'react';
import './Farmacia.css';

const Farmacia = () => {
  const [busca, setBusca] = useState('');
  const [categoriaAtiva, setCategoriaAtiva] = useState('Todas');
  const [nome, setNome] = useState('');
  const [contato, setContato] = useState('');
  const [endereco, setEndereco] = useState('');
  const [carrinho, setCarrinho] = useState([]);
  const [pagamento, setPagamento] = useState('Pix');
  const [trocoPara, setTrocoPara] = useState('');
  const [taxaEntrega, setTaxaEntrega] = useState(0);
  const [dadosImpressao, setDadosImpressao] = useState(null);
  const [mensagemSucesso, setMensagemSucesso] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const idParaImprimir = params.get('imprimir');
    if (idParaImprimir) {
      const pedidosSalvos = JSON.parse(localStorage.getItem('farma_pedidos') || '{}');
      const pedidoEncontrado = pedidosSalvos[idParaImprimir];
      if (pedidoEncontrado) {
        setDadosImpressao(pedidoEncontrado);
        setTimeout(() => { window.print(); }, 1500);
      }
    }
  }, []);

  const categorias = ['Todas', 'Medicamentos', 'Higiene', 'Perfumaria', 'Suplementos', 'Ofertas'];

  const bairros = [
    { nome: 'Retirar na Loja', taxa: 0 },
    { nome: 'Centro', taxa: 5.00 },
    { nome: 'Planalto', taxa: 10.00 },
  ];

  const produtos = [
    { id: 1, categoria: 'Medicamentos', nome: 'Dipirona 500mg (10 comprimidos)', preco: 4.50, img: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=400' },
    { id: 2, categoria: 'Ofertas', nome: 'Vitamina C 1g (10 pastilhas)', preco: 18.00, img: 'https://images.unsplash.com/photo-1616670876400-3490ca074728?w=400' },
    { id: 3, categoria: 'Perfumaria', nome: 'Desodorante Aerosol 48h', preco: 14.50, img: 'https://images.unsplash.com/photo-1594035910387-fea47794261f?w=400' },
    { id: 4, categoria: 'Higiene', nome: 'Sabonete Líquido 250ml', preco: 12.90, img: 'https://images.unsplash.com/photo-1600857062241-98e5dba7f214?w=400' },
  ];

  const adicionarAoCarrinho = (p) => {
    setCarrinho([...carrinho, { idU: Date.now(), nome: p.nome, preco: p.preco }]);
    setMensagemSucesso(`${p.nome} adicionado!`);
    setTimeout(() => setMensagemSucesso(''), 2000);
  };

  const removerDoCarrinho = (idU) => {
    setCarrinho(carrinho.filter(item => item.idU !== idU));
  };

  const finalizarPedido = () => {
    if (!nome || !endereco) return alert("Preencha Nome e Endereço!");
    if (carrinho.length === 0) return alert("Sua cesta está vazia!");

    const idPedido = Math.floor(1000 + Math.random() * 9000);
    const totalItens = carrinho.reduce((a, b) => a + b.preco, 0);
    const totalFinal = (totalItens + parseFloat(taxaEntrega)).toFixed(2);

    const pedido = {
      id: idPedido, cliente: nome, contato: contato, endereco: endereco,
      itens: carrinho.map(i => i.nome).join(', '), total: totalFinal,
      pagamento: pagamento, troco: pagamento === 'Dinheiro' ? trocoPara : 'N/A',
      data: new Date().toLocaleString('pt-BR')
    };

    const storage = JSON.parse(localStorage.getItem('farma_pedidos') || '{}');
    storage[idPedido] = pedido;
    localStorage.setItem('farma_pedidos', JSON.stringify(storage));

    const linkImp = `${window.location.origin}${window.location.pathname}?imprimir=${idPedido}`;
    let texto = `*NOVO PEDIDO - FARMA JÁ #${idPedido}*\n\n👤 *Cliente:* ${nome}\n📍 *Endereço:* ${endereco}\n💳 *Pagamento:* ${pagamento}\n`;
    if (pagamento === 'Dinheiro' && trocoPara) texto += `💵 *Troco para:* R$ ${trocoPara}\n`;
    texto += `--------------------------\n`;
    carrinho.forEach(item => texto += `• ${item.nome} - R$ ${item.preco.toFixed(2)}\n`);
    texto += `--------------------------\n💰 *TOTAL: R$ ${totalFinal}*\n\n🖨️ *RECIBO:* ${linkImp}`;

    window.open(`https://api.whatsapp.com/send?phone=5531999894058&text=${encodeURIComponent(texto)}`);
  };

  if (dadosImpressao) {
    return (
      <div className="impressao-pdf-fundo">
        <div className="cupom-corpo">
          <h1>FARMA JÁ</h1>
          <p>PEDIDO: #{dadosImpressao.id}</p>
          <div className="tracejado"></div>
          <p><b>DATA:</b> {dadosImpressao.data}</p>
          <p><b>CLIENTE:</b> {dadosImpressao.cliente}</p>
          <p><b>END:</b> {dadosImpressao.endereco}</p>
          <p><b>PAGAMENTO:</b> {dadosImpressao.pagamento}</p>
          {dadosImpressao.troco !== 'N/A' && <p><b>TROCO PARA:</b> R$ {dadosImpressao.troco}</p>}
          <div className="tracejado"></div>
          <p><b>ITENS:</b></p>
          <p>{dadosImpressao.itens}</p>
          <div className="tracejado"></div>
          <h2 style={{textAlign: 'right'}}>TOTAL: R$ {dadosImpressao.total}</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      {mensagemSucesso && <div className="toast">✅ {mensagemSucesso}</div>}
      <header className="main-header">
        <h1>⚕️ Farma Já</h1>
        <input type="text" placeholder="Buscar medicamento..." onChange={(e) => setBusca(e.target.value)} />
        <div className="tabs">
          {categorias.map(cat => (
            <button key={cat} onClick={() => setCategoriaAtiva(cat)} className={categoriaAtiva === cat ? 'tab active' : 'tab'}>
              {cat}
            </button>
          ))}
        </div>
      </header>

      <div className="grid">
        {produtos.filter(p => (categoriaAtiva === 'Todas' || p.categoria === categoriaAtiva)).filter(p => p.nome.toLowerCase().includes(busca.toLowerCase())).map(p => (
          <div key={p.id} className="card">
            {p.categoria === 'Ofertas' && <span className="badge">OFERTA</span>}
            <img src={p.img} alt="" />
            <h4>{p.nome}</h4>
            <p className="price">R$ {p.preco.toFixed(2)}</p>
            <button onClick={() => adicionarAoCarrinho(p)}>ADICIONAR</button>
          </div>
        ))}
      </div>

      <div className="checkout">
        <h2>🛒 Minha Cesta</h2>
        <div className="itens-lista-cesta">
          {carrinho.length === 0 ? <p style={{color: '#999', fontSize: '14px'}}>Sua cesta está vazia...</p> : 
            carrinho.map(item => (
              <div key={item.idU} className="item-cesta">
                <span>{item.nome}</span>
                <div>
                  <b>R$ {item.preco.toFixed(2)}</b>
                  <button onClick={() => removerDoCarrinho(item.idU)} className="btn-remover">×</button>
                </div>
              </div>
            ))
          }
        </div>

        <div className="form">
          <input placeholder="Seu Nome" onChange={e => setNome(e.target.value)} />
          <input placeholder="WhatsApp" onChange={e => setContato(e.target.value)} />
          <textarea placeholder="Endereço Completo para Entrega" onChange={e => setEndereco(e.target.value)} />
          <div className="row">
            <select onChange={e => setTaxaEntrega(e.target.value)}>
              {bairros.map(b => <option key={b.nome} value={b.taxa}>{b.nome}</option>)}
            </select>
            <select onChange={e => setPagamento(e.target.value)}>
              <option value="Pix">Pix</option>
              <option value="Cartão">Cartão</option>
              <option value="Dinheiro">Dinheiro</option>
            </select>
          </div>
          {pagamento === 'Dinheiro' && <input type="number" placeholder="Troco para quanto?" className="troco-input" onChange={e => setTrocoPara(e.target.value)} />}
        </div>
        <div className="total-box">Total: R$ {(carrinho.reduce((a, b) => a + b.preco, 0) + parseFloat(taxaEntrega)).toFixed(2)}</div>
        <button className="btn-finish" onClick={finalizarPedido}>✅ FINALIZAR PEDIDO</button>
      </div>
    </div>
  );
};

export default Farmacia;